import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CrudItemComponent, NavItem } from '@hutsix/ngxh6';
import { JobCardInterface } from '../../../../../_generated/api_interfaces/api/jobCard.interface';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-task-progress',
    templateUrl: './job-progress.component.html',
    styleUrls: ['./job-progress.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class JobProgressComponent {
    @Input() public job: Partial<{ noOfTasks: number; noOfIncompleteTasks: number; referredToDipl: boolean }>;
}
